// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-model{margin-right:2px !important}@media(max-width: 300px){.search-model{margin-right:0px !important;display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
